import React, { useRef } from 'react';
import { Tooltip, Typography } from 'antd';
import { DeleteOutlined, FileOutlined, FilePdfOutlined, FileWordOutlined, PlusOutlined } from '@ant-design/icons';

;

const getFileTypeIcon = (file) => {
    const type = file.type;


    if (type.startsWith('image/')) {
        return URL.createObjectURL(file); // return image preview
    }

    if (type == 'application/pdf') {
        return <FilePdfOutlined style={{ fontSize: 20, color: 'red' }} />// replace with your PDF icon path
    }

    if (
        type.includes('word') ||
        file.name.endsWith('.doc') ||
        file.name.endsWith('.docx')
    ) {
        return <FileWordOutlined style={{ fontSize: 20, color: '#1890ff' }} />;
    }

    return <FileOutlined style={{ fontSize: 20, color: '#8c8c8c' }} />;
};

const AttachmentUploader = ({ attachments, setAttachments }) => {
    const inputRef = useRef();
    const { Title } = Typography
    const handleButtonClick = () => {
        inputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setAttachments(prev => [...prev, ...files]);
        e.target.value = null;
    };

    const handleRemove = (fileToRemove) => {
        setAttachments(prev => prev.filter(file => file !== fileToRemove));
    };

    return (
        <div>
            {/* Hidden file input */}
            <input
                type="file"
                ref={inputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                multiple
            />

            <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column" }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Title level={4}>Attachment</Title>
                    <Tooltip title="Add Attachment in Notes">
                        <button
                            style={{
                                width: '26px',
                                height: '26px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '10px',
                                borderRadius: '50%',
                                border: 'none',
                            }}
                            onClick={() => handleButtonClick()}
                        >
                            <PlusOutlined
                                style={{ fontSize: '15px' }}
                            />
                        </button>
                    </Tooltip>
                </div>


                {/* File previews */}
                <div style={{
                    display: 'flex',
                    gap: '8px',
                    marginTop: 10,
                    flexWrap: 'wrap',
                    maxWidth: '100%',
                    marginLeft: "12px"
                }}>
                    {attachments.map((file, idx) => {
                        const icon = getFileTypeIcon(file);

                        return (
                            <div
                                key={idx}
                                style={{
                                    width: 70,
                                    height: 70,
                                    border: '1px solid #ccc',
                                    borderRadius: 6,
                                    position: 'relative',
                                    overflow: 'visible',
                                    backgroundColor: '#fafafa',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                }}
                            >
                                <Tooltip title={file.name}>
                                    {
                                        file.type.startsWith('image/')
                                            ? <img src={icon} alt="img" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                                            : icon
                                    }
                                </Tooltip>
                                <Tooltip title="Delete">

                                    <DeleteOutlined
                                        onClick={() => handleRemove(file)}
                                        style={{
                                            position: 'absolute',
                                            top: '-6px',
                                            right: '-6px',
                                            color: '#f5222d',
                                            backgroundColor: '#fff',
                                            borderRadius: '50%',
                                            fontSize: '14px',
                                            padding: '2px',
                                            boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                                            zIndex: 10, // ensure it stays on top
                                            cursor: 'pointer',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default AttachmentUploader;
